import styled from "@emotion/styled";
// import { ProfileIcon } from "components/general/ProfileIcon/ProfileIcon";
import { WalletIcon } from "components/general/UserIcons/WalletIcon/WalletIcon";
import { useAccount } from "wagmi";

export const ConnectedVia = () => {
  const { connector } = useAccount();

  if (connector == null) {
    return null;
  }

  return (
    <ConnectedViaContainer>
      <WalletIcon
        connector={connector}
        options={{
          size: 18,
          withBackground: false,
          borderRadius: "50%",
        }}
      />
      <ConnectedViaTitle>Connected via {connector.name}</ConnectedViaTitle>
    </ConnectedViaContainer>
  );
};

// Sub-components

const ConnectedViaContainer = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`;

const ConnectedViaTitle = styled.h3`
  color: ${props => props.theme.font.primary.default};
  font-size: ${props => props.theme.fontSize[4]};
  font-family: ${props => props.theme.fontFamilies.Primary};
  line-height: 130%;
  margin-bottom: 0;
  position: relative;
  top: 1px;
`;
